import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-73769d5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container sticky-top" }
const _hoisted_2 = {
  id: "siteHeaderContent",
  class: "navbar navbar-expand-lg"
}
const _hoisted_3 = { class: "container-fluid h-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarContent",
  "aria-controls": "navbarContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "navbar-collapse collapse h-100",
  id: "navbarContent"
}
const _hoisted_6 = { class: "navbar-nav nav navbar-left" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = {
  class: "nav-link active",
  "aria-current": "page",
  href: "#homeSection"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "spacer" })
], -1))
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = {
  class: "nav-link",
  href: "#mediaSection"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "spacer" })
], -1))
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = {
  class: "nav-link",
  href: "#plumberSectionOne"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  id: "logo",
  class: "navbar-brand mx-auto",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logoImage",
    class: "h-auto",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_16 = { class: "navbar-nav nav navbar-right" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = {
  class: "nav-link",
  href: "#comingSoonSection"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "spacer" })
], -1))
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = {
  class: "nav-link",
  href: "#communitySection"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "spacer" })
], -1))
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = {
  class: "nav-link",
  href: "https://github.com/Zweistein2/AgrarMonitor/releases"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t("About")), 1)
            ]),
            _hoisted_9,
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t("Media")), 1)
            ]),
            _hoisted_12,
            _createElementVNode("li", _hoisted_13, [
              _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t("Plumber")), 1)
            ])
          ]),
          _hoisted_15,
          _createElementVNode("ul", _hoisted_16, [
            _createElementVNode("li", _hoisted_17, [
              _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.$t("ComingSoon")), 1)
            ]),
            _hoisted_19,
            _createElementVNode("li", _hoisted_20, [
              _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.$t("Community")), 1)
            ]),
            _hoisted_22,
            _createElementVNode("li", _hoisted_23, [
              _createElementVNode("a", _hoisted_24, _toDisplayString(_ctx.$t("Download")), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}